export const homeObj = {
    id:'sobre',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'João Vítor dos santos Miotti',
    headline: 'Desenvolvedor Júnior/Pleno React',
    description: 'Tudo bem? Obrigado por estar vizualizando meu curriculo. Vamos lá, tenho 22 anos e sou bastante extrovertido. Gosto bastante de conversar, interagir socialmente nos momentos adequados e de trocar informações para deixar o ambiente mais leve, estudo bastante e sempre quero ampliar meu conhecimento, por que possuo objetivos a longo prazo que necessitam que eu seja um excelente profissional. Apesar de que possuo dificuldade para guardar informações sempre tento me manter atualizado para que isso não afete meu desempenho.',
    dark: true,
    primary: true,
    buttonLabel: 'Certificações',
    darkText: false,
    imgStart: false,
    img: require('../../img/1.svg'),
    alt: 'Eu'
}

export const homeObj2 = {
    id:'formacao',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Formação',
    headline: 'UniProjeção - Analise e Desenvolvimento de sistemas',
    description: 'Tive uma graduação bem completa, tanto na questão de direcionamento de mercado quanto de estudos de linguagens que seriam utilizadas de uma melhor forma em alguns anos. Fiz neste meio tempo um networking muito bom, conheci professores e amigos da área que levei tanto pra vida profissional quanto para pessoal. Tive um direcionamento maior para o BackEnd/ B.I, porém com os projetos fornecidos pelos tutores todos os aspectos da programação foram esclarecidos.',
    dark: true,
    primary: true,
    buttonLabel: 'Certificações',
    darkText: true,
    imgStart: true,
    img: require('../../img/3.svg'),
    alt: 'Eu'
}

export const homeObj3 = {
    id:'experiencia',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Experiencias profissionais',
    headline: 'Empresas das quais fiz parte',
    description: 'Trabalhei em n sei onde e das quantas',
    dark: true,
    primary: true,
    buttonLabel: 'Formações',
    darkText: false,
    imgStart: false,
    img: require('../../img/1.svg'),
    alt: 'Eu'
}